import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

export class SymbolAnimation extends PIXI.Sprite {
    private _frameAnimation: TimelineSprite;
    private _fireContainer: PIXI.Sprite;
    private _updated: boolean = false;
    private _isPlayingFire: boolean = false;
    private _blueThunder: TimelineSprite;
    private _blueThunder2: TimelineSprite;
    private _blueThunder3: TimelineSprite;

    constructor() {
        super();
        this.anchor.set(0.5, 0.5);
    }

    public initAnimation(): void {
        this._fireContainer = new PIXI.Sprite();
        this._frameAnimation = this.createTimelineSprite("winToggle", 20);
        this.addChild(this._frameAnimation);
        this.visible = false;
        this._isPlayingFire = false;
        this._updated = false;
    }

    public initThunderAnim(): void {
        this._blueThunder = this.createTimelineSprite("blue_thunder", undefined, PIXI.BLEND_MODES.ADD);
        this._blueThunder2 = this.createTimelineSprite("blue_thunder", undefined, PIXI.BLEND_MODES.ADD);
        this._blueThunder3 = this.createTimelineSprite("blue_thunder", undefined, PIXI.BLEND_MODES.ADD);
    }

    public playThunderAnimation(mSize: number, reelSize: number) {
        this._blueThunder.rotation = 1.5;
        this._blueThunder3.rotation = 2;
        const sStep = 592 / reelSize;
        if (mSize == 3) {
            this._blueThunder.y = sStep / 2;
            this._blueThunder2.y = sStep;
            this._blueThunder3.y = 1.5 * sStep + 20;
            this._blueThunder3.show();
            this._blueThunder3.playLoop();
        } else {
            this._blueThunder.y = sStep / 2 - 25;
            this._blueThunder2.y = 2 * sStep / 2 - 25;
        }

        this._blueThunder.show();
        this._blueThunder2.show();

        this._blueThunder2.playLoop();
        this._blueThunder.playLoop();
    }

    public playSymbolWinAnimation(symHeight: number, stackedNumber: number, withFrame: boolean = false, loop?: boolean): TimelineLite {
        if (!this._updated) {
            this.visible = true;
            this.scale.set(1, (symHeight * stackedNumber) / 148);
            this.scale.y = (this.scale.y) + 0.05;
            const anchorY: number = MathHelper.roundToDecimals(Math.min(Math.max(74, symHeight / 2), 148 - symHeight / 2) / 148, 2);
            this.anchor.set(0.5, anchorY);
        }
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this.visible = true;
            if (!this._isPlayingFire) {
                this._isPlayingFire = true;
                if (loop) {
                    this._frameAnimation.show();
                    this._frameAnimation.playLoop();
                } else if (withFrame) {
                    this._frameAnimation.show();
                    this._frameAnimation.getAnimation();
                }
            }
        }, 0);
        return tl;
    }
    public playSymbolWinAnimationForIndiSymWin(symHeight: number, stackedNumber: number): TimelineLite {
        if (!this._updated) {
            this.visible = true;
            this.scale.set(1, (symHeight * stackedNumber) / 148);
            this.scale.y = (this.scale.y) + 0.05;
            const anchorY: number = MathHelper.roundToDecimals(Math.min(Math.max(74, symHeight / 2), 148 - symHeight / 2) / 148, 2);
            this.anchor.set(0.5, anchorY);
        }
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this.visible = true;
            if (!this._isPlayingFire) {
                this._isPlayingFire = true;
                    this._frameAnimation.show();
            }
        }, 0);
        tl.add(this._frameAnimation.getAnimation())
        return tl;
    }

    public resetThunder(): void {
        this._blueThunder.hide();
        this._blueThunder2.hide();
        this._blueThunder3.hide();
        this._blueThunder.stopLoop();
        this._blueThunder2.stopLoop();
        this._blueThunder3.stopLoop();
    }

    public reset(): void {
        this.visible = false;
        this.scale.set(1, 1);
        this._frameAnimation.hide();
        this._frameAnimation.stopLoop();
        this._isPlayingFire = false;
        this._updated = false;
    }

    private createTimelineSprite(resourceName: string, fps?: number, mode?: PIXI.BLEND_MODES): TimelineSprite {
        if (!fps) fps = 30;
        const sprite = new TimelineSprite(GameResources.getTextures(resourceName), fps);
        sprite.anchor.set(0.5, 0.5);
        sprite.position.set(0, 0);
        if (mode) sprite.blendMode = mode;
        this.addChild(sprite);
        sprite.hide();
        return sprite;
    }
}